// Keep the existing Phosphor version, glyph classes and deferred loading on scoped PDPs.
(() => {
  for (const weight of ['regular', 'bold', 'fill']) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.type = 'text/css';
    stylesheet.href = `https://cdn.jsdelivr.net/npm/@phosphor-icons/web@2.1.2/src/${weight}/style.css`;
    document.head.appendChild(stylesheet);
  }
})();
